import React from 'react';

const StatusGroup = ({ tickets }) => {
  return (
    <div className="kanban-board">
      {Object.keys(tickets).map((status) => (
        <div key={status} className='kanban-column'>
          <div className='fix'>
            <img src={`./images/${status}.svg`} alt=""/>
            <h3>{status}</h3>
          </div>
          {tickets[status].map((ticket) => (
            <div key={ticket.id} className="ticket">
              <p>{ticket.id}</p>
              <h3>{ticket.title}</h3>
              <div className='fix'>
              <img src={`./images/${ticket.priority}.svg`} alt=""/>
                <p>{ticket.tag.join(', ')}</p>
              </div>
              
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default StatusGroup;
